import Vue from "vue";
import Index from "@/pages/Index.vue";

// mixins
import LoginMixin from "@/mixins/login";
import TypeMixin from "@/mixins/type";
import BetterPicker from "@/plugins/better-picker/";
Vue.use(BetterPicker);
import msgbox from '@/plugins/message-box';
Vue.use(msgbox);
import { weixin } from "@/utils/wxconfig";
weixin.config();
Vue.config.productionTip = false;


new Vue({
	template: '<div id="app"></div>',
	mixins: [LoginMixin, TypeMixin],
	render: h => h(Index),
}).$mount("#app");
